

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import Header from '../headerFooter/header';
// import HomeFooter from '../homepage/homefooter';
// import './classesandForm.css'; // Unified CSS

// const FemaleWellnessForm = () => {
//   const navigate = useNavigate();
  

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const [formData, setFormData] = useState({
//     name: '', email: '', dob: '', gender: '', phone: '',
//     timeSlot: '', otherTime: '', experience: '',
//     goals: { weightManagement: false, pcosSupport: false, hormonalBalance: false, betterSleep: false, menstrualHealth: false, stressRelief: false, flexibilityStrength: false, other: false },
//     otherGoal: '', challenges: '',
//   });

//   const [errors, setErrors] = useState({});

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleCheckboxChange = (e) => {
//     const { name, checked } = e.target;
//     setFormData(prev => ({ ...prev, goals: { ...prev.goals, [name]: checked } }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = 'Name is required';
//     if (!formData.email.trim()) newErrors.email = 'Email is required';
//     if (!formData.phone || formData.phone.length < 10) newErrors.phone = 'Valid phone required';
//     if (!formData.dob) newErrors.dob = 'Date of Birth required';
//     if (!formData.gender) newErrors.gender = 'Gender required';
//     if (!formData.timeSlot) newErrors.timeSlot = 'Select a time slot';
//     if (!Object.values(formData.goals).some(Boolean)) newErrors.goals = 'Select at least one goal';
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       const selectedGoals = Object.keys(formData.goals).filter(k => formData.goals[k]).join(', ');
//       navigate('/payment', {
//         state: {
//           FemaleWellnessData: { ...formData, goals: selectedGoals },
//           productName: 'Female Wellness Batch',
//           amount, quantity: 1
//         }
//       });
//     }
//   };

//   return (
//     <div className="form-page-wrapper">
//       <Header />
      
//       <form onSubmit={handleSubmit} className="satvic-form">
//         <h2>Female Wellness Program</h2>
//         <p className="amount-display">Monthly Subscription: ₹{item.price}</p>

//         <div className="batch-info-box">
//           <h3>Batch Details</h3>
//           <ul>
//             <li><strong>Days:</strong> Monday - Friday</li>
//             {/* <li><strong>Timings:</strong> 6:30 AM & 6:00 PM (IST)</li> */}
//             <li><strong>Focus:</strong> Hormonal balance, PCOD, Strength & Flexibility</li>
//           </ul>
//         </div>

//         <div className="form-grid">
//           {/* Left Col */}
//           <div>
//             <label>Full Name *</label>
//             <input type="text" name="name" value={formData.name} onChange={handleInputChange} />
//             {errors.name && <p className="error-message">{errors.name}</p>}
//           </div>

//           <div>
//             <label>Email Address *</label>
//             <input type="email" name="email" value={formData.email} onChange={handleInputChange} />
//             {errors.email && <p className="error-message">{errors.email}</p>}
//           </div>

//           <div>
//             <label>Date of Birth *</label>
//             <input type="date" name="dob" max={new Date().toISOString().split("T")[0]} value={formData.dob} onChange={handleInputChange} />
//             {errors.dob && <p className="error-message">{errors.dob}</p>}
//           </div>

//           <div>
//             <label>Gender *</label>
//             <select name="gender" value={formData.gender} onChange={handleInputChange}>
//               <option value="">Select Gender</option>
//               <option value="Female">Female</option>
//               <option value="Male">Male</option>
//               <option value="Other">Other</option>
//             </select>
//             {errors.gender && <p className="error-message">{errors.gender}</p>}
//           </div>

//           <div className="full-width">
//             <label>Phone Number (WhatsApp) *</label>
//             <PhoneInput
//               country={'in'}
//               value={formData.phone}
//               onChange={(phone) => setFormData({ ...formData, phone })}
//             />
//             {errors.phone && <p className="error-message">{errors.phone}</p>}
//           </div>

//           <div className="full-width">
//             <label>Preferred Time Slot *</label>
//             <select name="timeSlot" value={formData.timeSlot} onChange={handleInputChange}>
//               <option value="">Select Slot</option>
//               <option value="Morning ">Morning </option>
//               <option value="Evening ">Evening </option>
//               <option value="Other">Other</option>
//             </select>
//             {errors.timeSlot && <p className="error-message">{errors.timeSlot}</p>}
//           </div>

//           <div className="full-width">
//             <label>Wellness Goals (Select all that apply) *</label>
//             <div className="selection-group">
//                {/* Mapping typical goals */}
//                {['weightManagement', 'pcosSupport', 'hormonalBalance', 'betterSleep', 'stressRelief', 'flexibilityStrength'].map(key => (
//                  <label key={key}>
//                    <input type="checkbox" name={key} checked={formData.goals[key]} onChange={handleCheckboxChange} />
//                    {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
//                  </label>
//                ))}
//             </div>
//             {errors.goals && <p className="error-message">{errors.goals}</p>}
//           </div>

//           <div className="full-width">
//             <label>Any specific health challenges?</label>
//             <textarea name="challenges" rows="3" value={formData.challenges} onChange={handleInputChange} placeholder="Tell us how we can help..."></textarea>
//           </div>

//         </div>

//         <button type="submit" className="submit-btn">Proceed to Payment</button>
//       </form>
      
//       <HomeFooter />
//     </div>
//   );
// };

// // export default FemaleWellnessForm;
// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import Header from '../headerFooter/header';
// import HomeFooter from '../homepage/homefooter';
// import './classesandForm.css';

// const FemaleWellnessForm = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();

//   // If navigated from classes page
//   const initialProductName = state?.productName;
//   const initialAmount = state?.amount;
//   const initialDescription = state?.description;

//   const [item, setItem] = useState(
//     initialProductName && initialAmount
//       ? {
//           title: initialProductName,
//           price: initialAmount,
//           description: initialDescription,
//         }
//       : null
//   );

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     dob: '',
//     gender: '',
//     phone: '',
//     timeSlot: '',
//     experience: '',
//     goals: {
//       weightManagement: false,
//       pcosSupport: false,
//       hormonalBalance: false,
//       betterSleep: false,
//       stressRelief: false,
//       flexibilityStrength: false,
//     },
//     challenges: '',
//   });

//   const [errors, setErrors] = useState({});

//   // 🔹 Fallback fetch (page refresh / direct URL)
//   useEffect(() => {
//     if (item) return;

//     const fetchClass = async () => {
//       try {
//         const res = await fetch(
//           `${process.env.REACT_APP_API_URL}/api/classes`
//         );

//         if (!res.ok) throw new Error('Failed to fetch classes');

//         const data = await res.json();

//         const femaleWellness = data.find(
//           cls => cls.title === 'Female Wellness Program'
//         );

//         if (!femaleWellness) {
//           throw new Error('Female Wellness Program not found');
//         }

//         setItem(femaleWellness);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchClass();
//   }, [item]);

//   const handleInputChange = e => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleCheckboxChange = e => {
//     const { name, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       goals: { ...prev.goals, [name]: checked },
//     }));
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.name) newErrors.name = true;
//     if (!formData.email) newErrors.email = true;
//     if (!formData.phone) newErrors.phone = true;
//     if (!formData.dob) newErrors.dob = true;
//     if (!formData.gender) newErrors.gender = true;
//     if (!formData.timeSlot) newErrors.timeSlot = true;
//     if (!Object.values(formData.goals).some(Boolean))
//       newErrors.goals = true;

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = e => {
//     e.preventDefault();
//     if (!item) return;

//     if (validateForm()) {
//       const selectedGoals = Object.keys(formData.goals)
//         .filter(k => formData.goals[k])
//         .join(', ');

//       navigate('/payment', {
//         state: {
//           formType: 'FemaleWellness',
//           productName: item.title,
//           amount: item.price,
//           quantity: 1,
//           FemaleWellnessData: {
//             ...formData,
//             goals: selectedGoals,
//           },
//         },
//       });
//     }
//   };

//   if (!item) {
//     return <p style={{ textAlign: 'center' }}>Loading...</p>;
//   }

//   return (
//     <div className="form-page-wrapper">
//       <Header />

//       <form onSubmit={handleSubmit} className="satvic-form">
//         <h2>{item.title}</h2>

//         <p className="amount-display">
//           Monthly Subscription: ₹{item.price}
//         </p>

//         {item.description && (
//           <div className="batch-info-box">
//             <p>{item.description}</p>
//           </div>
//         )}

//         <div className="form-grid">
//           <div>
//             <label>Full Name *</label>
//             <input name="name" value={formData.name} onChange={handleInputChange} />
//             {errors.name && <p className="error-message">Required</p>}
//           </div>

//           <div>
//             <label>Email *</label>
//             <input name="email" value={formData.email} onChange={handleInputChange} />
//             {errors.email && <p className="error-message">Required</p>}
//           </div>

//           <div>
//             <label>Date of Birth *</label>
//             <input
//               type="date"
//               name="dob"
//               max={new Date().toISOString().split('T')[0]}
//               value={formData.dob}
//               onChange={handleInputChange}
//             />
//             {errors.dob && <p className="error-message">Required</p>}
//           </div>

//           <div>
//             <label>Gender *</label>
//             <select name="gender" value={formData.gender} onChange={handleInputChange}>
//               <option value="">Select</option>
//               <option value="Female">Female</option>
//               <option value="Male">Male</option>
//               <option value="Other">Other</option>
//             </select>
//             {errors.gender && <p className="error-message">Required</p>}
//           </div>

//           <div className="full-width">
//             <label>Phone (WhatsApp) *</label>
//             <PhoneInput
//               country="in"
//               value={formData.phone}
//               onChange={phone => setFormData(prev => ({ ...prev, phone }))}
//             />
//             {errors.phone && <p className="error-message">Required</p>}
//           </div>

//           <div className="full-width">
//             <label>Preferred Time Slot *</label>
//             <select name="timeSlot" value={formData.timeSlot} onChange={handleInputChange}>
//               <option value="">Select</option>
//               <option value="Morning">Morning</option>
//               <option value="Evening">Evening</option>
//             </select>
//             {errors.timeSlot && <p className="error-message">Required</p>}
//           </div>

//           <div className="full-width">
//             <label>Wellness Goals *</label>
//             <div className="selection-group">
//               {Object.keys(formData.goals).map(key => (
//                 <label key={key}>
//                   <input
//                     type="checkbox"
//                     name={key}
//                     checked={formData.goals[key]}
//                     onChange={handleCheckboxChange}
//                   />
//                   {key.replace(/([A-Z])/g, ' $1')}
//                 </label>
//               ))}
//             </div>
//             {errors.goals && <p className="error-message">Select at least one</p>}
//           </div>

//           <div className="full-width">
//             <label>Health Challenges</label>
//             <textarea
//               name="challenges"
//               rows="3"
//               value={formData.challenges}
//               onChange={handleInputChange}
//             />
//           </div>
//         </div>

//         <button type="submit" className="submit-btn">
//           Proceed to Payment
//         </button>
//       </form>

//       <HomeFooter />
//     </div>
//   );
// };

// export default FemaleWellnessForm;
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import './classesandForm.css';

const FemaleWellnessForm = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const initialProductName = state?.productName;
  const initialAmount = state?.amount;
  const initialDescription = state?.description;

  const [item, setItem] = useState(
    initialProductName && initialAmount
      ? {
          title: initialProductName,
          price: initialAmount,
          description: initialDescription,
        }
      : null
  );

  const [consent, setConsent] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    dob: '',
    gender: '',
    phone: '',
    timeSlot: '',
    experience: '',
    goals: {
      weightManagement: false,
      pcosSupport: false,
      hormonalBalance: false,
      betterSleep: false,
      stressRelief: false,
      flexibilityStrength: false,
    },
    challenges: '',
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (item) return;

    const fetchClass = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/classes`);
        if (!res.ok) throw new Error('Failed to fetch classes');

        const data = await res.json();
        const femaleWellness = data.find(
          cls => cls.title === 'Female Wellness Program'
        );

        if (!femaleWellness) {
          throw new Error('Female Wellness Program not found');
        }

        setItem(femaleWellness);
      } catch (err) {
        console.error(err);
      }
    };

    fetchClass();
  }, [item]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = e => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      goals: { ...prev.goals, [name]: checked },
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = true;
    if (!formData.email) newErrors.email = true;
    if (!formData.phone) newErrors.phone = true;
    if (!formData.dob) newErrors.dob = true;
    if (!formData.gender) newErrors.gender = true;
    if (!formData.timeSlot) newErrors.timeSlot = true;
    if (!Object.values(formData.goals).some(Boolean))
      newErrors.goals = true;
    if (!consent) newErrors.consent = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!item) return;

    if (validateForm()) {
      const selectedGoals = Object.keys(formData.goals)
        .filter(k => formData.goals[k])
        .join(', ');

      navigate('/payment', {
        state: {
          formType: 'FemaleWellness',
          productName: item.title,
          amount: item.price,
          quantity: 1,
          FemaleWellnessData: {
            ...formData,
            goals: selectedGoals,
          },
        },
      });
    }
  };

  if (!item) {
    return <p style={{ textAlign: 'center' }}>Loading...</p>;
  }

  return (
    <div className="form-page-wrapper">
      <Header />

      <form onSubmit={handleSubmit} className="satvic-form">
        <h2>{item.title}</h2>

        <p className="amount-display">
          Monthly Subscription: ₹{item.price}
        </p>

        {item.description && (
          <div className="batch-info-box">
            <p>{item.description}</p>
          </div>
        )}

        <div className="form-grid">
          <div>
            <label>Full Name *</label>
            <input name="name" value={formData.name} onChange={handleInputChange} />
            {errors.name && <p className="error-message">Required</p>}
          </div>

          <div>
            <label>Email *</label>
            <input name="email" value={formData.email} onChange={handleInputChange} />
            {errors.email && <p className="error-message">Required</p>}
          </div>

          <div>
            <label>Date of Birth *</label>
            <input
              type="date"
              name="dob"
              max={new Date().toISOString().split('T')[0]}
              value={formData.dob}
              onChange={handleInputChange}
            />
            {errors.dob && <p className="error-message">Required</p>}
          </div>

          <div>
            <label>Gender *</label>
            <select name="gender" value={formData.gender} onChange={handleInputChange}>
              <option value="">Select</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Other">Other</option>
            </select>
            {errors.gender && <p className="error-message">Required</p>}
          </div>

          <div className="full-width">
            <label>Phone (WhatsApp) *</label>
            <PhoneInput
              country="in"
              value={formData.phone}
              onChange={phone => setFormData(prev => ({ ...prev, phone }))}
            />
            {errors.phone && <p className="error-message">Required</p>}
          </div>

          <div className="full-width">
            <label>Preferred Time Slot *</label>
            <select name="timeSlot" value={formData.timeSlot} onChange={handleInputChange}>
              <option value="">Select</option>
              <option value="Morning">Morning</option>
              <option value="Evening">Evening</option>
            </select>
            {errors.timeSlot && <p className="error-message">Required</p>}
          </div>

          <div className="full-width">
            <label>Wellness Goals *</label>
            <div className="selection-group">
              {Object.keys(formData.goals).map(key => (
                <label key={key}>
                  <input
                    type="checkbox"
                    name={key}
                    checked={formData.goals[key]}
                    onChange={handleCheckboxChange}
                  />
                  {key.replace(/([A-Z])/g, ' $1')}
                </label>
              ))}
            </div>
            {errors.goals && <p className="error-message">Select at least one</p>}
          </div>

          <div className="full-width">
            <label>Any specific health challenges?</label>
            <textarea
              name="challenges"
              rows="3"
              value={formData.challenges}
              onChange={handleInputChange}
              placeholder="Tell us how we can help..."
            />
          </div>
        </div>

        {/* ✅ CONSENT (MANDATORY) */}
        <div className="full-width consent-box">
          <label className="consent-label">
            <input
              type="checkbox"
              checked={consent}
              onChange={e => {
                setConsent(e.target.checked);
                setErrors(prev => ({ ...prev, consent: false }));
              }}
            />
            <span>
              I agree to the{' '}
              <a href="http://localhost:3000/t&c" target="_blank" rel="noopener noreferrer">
                Terms & Conditions
              </a>{' '}
              and{' '}
              <a href="http://localhost:3000/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </span>
          </label>

          {errors.consent && (
            <p className="error-message">You must agree before proceeding</p>
          )}
        </div>

        <button
          type="submit"
          className="submit-btn"
          disabled={!consent}
        >
          Proceed to Payment
        </button>
      </form>

      <HomeFooter />
    </div>
  );
};

export default FemaleWellnessForm;
